// extracted by mini-css-extract-plugin
module.exports = {"root":"NewsletterChunkButton__root--q5Y4Q","button":"NewsletterChunkButton__button--BNwPI","icon":"NewsletterChunkButton__icon--2Tge2"};